import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './ui/App'
import './styles.css'
import './soft-ui.css'
import './composants.css'

const racine = document.getElementById('racine')
if (!racine) throw new Error('Élément #racine introuvable dans index.html')

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
